import { SelectVehicleFunc } from 'app/vehicles/components/SelectVehicleType/types'
import React from 'react'

export interface IContextValue {
  showSelection: SelectVehicleFunc
  hasBeenProvided: boolean
}

const defaultSelectVehicleTypeContext: IContextValue = {
  showSelection: (() => {}) as any,
  hasBeenProvided: false
}

export const SelectVehicleTypeContext = React.createContext<IContextValue>(defaultSelectVehicleTypeContext)
